<template>
  <div class="wrap">
    <b-card class="shadow-sm border">
      <template #header>
        <esg-card-header>
          <slot name="title">
            <div class="d-flex flex-column">
              <span v-if="title" class="title">{{ title }}</span>
              <span v-if="subtitle" class="subtitle">{{ subtitle }}</span>
            </div>
          </slot>
          <template #actions>
            <slot name="actions"></slot>
          </template>
        </esg-card-header>
      </template>
      <template #default>
        <slot></slot>
      </template>
    </b-card>
  </div>
</template>

<script>
import EsgCardHeader from "@/components/esg/base/EsgBaseCardHeader.vue";

export default {
  components: { EsgCardHeader },
  props: ['title', 'subtitle', 'grid']
}
</script>

<style scoped>
div[class *= 'col'] .wrap {
  padding-top: .5rem;
  padding-bottom: .5rem;
  font-family: NanumGothic, serif;
}

.card {
  border-radius: .5rem;
}

.card .card-header {
  display: flex;
  align-items: center;
  min-height: 3.5rem;
  border-radius: .5rem .5rem 0 0;
  padding-left: 1.125rem;
  padding-right: 1.125rem;
}

.card .card-body {
  border-radius: .5rem;
  padding: 0.5rem;
}

.title {
  font-size: 1rem;
  font-family: NanumGothic, serif;
  font-weight: bold;
  white-space: nowrap;
}

.subtitle {
  font-size: .875rem;
  font-family: NanumGothic, serif;
  font-weight: normal;
  white-space: nowrap;
}
</style>